import type { ChangeEvent, FC } from 'react';

type CheckboxPropTypes = {
  label?: string;
  name: string;
  id?: string;
  onChange?: (value: ChangeEvent<HTMLInputElement>) => void;
  checked?: boolean;
};

const Checkbox: FC<CheckboxPropTypes> = ({ checked, name, id, label, onChange }) => {
  return (
    <div className="flex items-center gap-3 py-[5px]">
      <input
        onChange={onChange}
        checked={checked}
        name={id || name}
        id={id || name}
        type="checkbox"
        className="appearance-none flex-shrink-0 checked:bg-1xbet-checked-icon w-[18px] h-[18px] md:w-5 md:h-5 bg-center bg-no-repeat bg-contain checked:border-none rounded-[1px] border-1xbet-gray-100 border-2 md:border-[3px] cursor-pointer hover:bg-sz-blue-100/10"
      />
      <label
        className="text-base md:text-xl font-normal text-1xbet-gray-100 leading-4 md:leading-[30px]"
        htmlFor={id || name}
      >
        {label}
      </label>
    </div>
  );
};

export { Checkbox };
